import api from "../../../../../../features/auth/axiosConfig";

export const fetchOrderDetails = (orderid: string) =>
  api.get(`/app/pos/v2/order/${orderid}`);

export const updateOrderStatus = (orderid: string, status: string) =>
  api.put(`/app/pos/v2/order/${orderid}`, { OrderStatus: status });

export const cancelOrder = (orderid: string) =>
  api.put(`/app/pos/v2/order/${orderid}`, { OrderStatus: "Cancelled" });

export const confirmPayment = (orderid: string, payload: any) =>
  api.patch(`/app/pos/v2/order/${orderid}`, payload);

export const fetchUsers = () =>
  api.get("/pos/v2/get_user");


